import React from 'react'
import ErrorPage from 'next/error'
import { groq } from 'next-sanity'
import { useRouter } from 'next/router'
import { usePreviewSubscription } from '@/lib/sanity'
import { getClient } from '@/lib/sanity.server'
import { Layout } from '@/components/layout/app'
import { SEO } from '@/components/seo'
import { Loader } from '@/components/shared/loader'


function filterDataToSingleItem(data, preview) {
  if (!Array.isArray(data)) {
    return data
  }
  if (data.length === 1) {
    return data[0]
  }
  if (preview) {
    return data.find((item) => item._id.startsWith(`drafts.`)) || data[0]
  }
  return data[0]
}

export async function getStaticProps({ params, preview = false }) {

  const query = groq`*[_type in ["appPage", "siteSettings", "navigation"]][0]{
    "siteSettings": *[_type == "siteSettings"][0],
    "appPages": *[_type == "appPage" && slug.current == "login"]
    {
      ...,
      "slug": slug.current,
      "contentComponents": contentComponents[] {
        ...,
      },
      "appAccessLevel": appAccess.accessLevel,
      "appAccessRoles": appAccess.allowedRoles[]->slug.current,
    }[0],
    "siteNav": *[_type == "navigation" && _id == "mainNav"][0]["links"],
    "topNav": *[_type == "navigation" && _id == "topNav"][0]["links"],
    "topFooterNav": *[_type == "navigation" && _id == "topFooterNav"][0]["links"],
    "bottomFooterNav": *[_type == "navigation" && _id == "bottomFooterNav"][0]["links"],
  }`

  const queryParams = { slug: "contact" }
  const data = await getClient(preview).fetch(query, queryParams)

  if (!data) return { notFound: true }
  const page = filterDataToSingleItem(data, preview)

  return {
    props: {
      preview,
      data: { page, query, queryParams },
    },
    revalidate: 60
  }
}

export default function Page({ data, preview }) {
  const { data: previewData } = usePreviewSubscription(data?.query, {
    params: data?.queryParams ?? {},
    initialData: data?.page,
    enabled: preview,
  })

  const page = filterDataToSingleItem(previewData, preview)

  const appPage = page?.appPages || null
  const siteSettings = page?.siteSettings || null
  const siteNav = page?.siteNav || null
  const topNav = page?.topNav || null
  const topFooterNav = page?.topFooterNav || null
  const bottomFooterNav = page?.bottomFooterNav || null
  const contentComponentHero = page?.appPages?.contentComponentHero || null
  const contentComponents = page?.appPages?.contentComponents || null
  const appAccessLevel = page?.appPages?.appAccess?.accessLevel || 'anonymous'

  const router = useRouter()
  if (!router.isFallback && !appPage?.slug) {
    return <ErrorPage statusCode={404} />
  }
  if (router.isFallback) {
    return <Loader />
  }
  return (<>
    <SEO page={appPage} site={siteSettings} path={appPage?.slug} />
    <Layout preview={preview} asPath={'contact'} siteNav={siteNav} topNav={topNav} topFooterNav={topFooterNav} bottomFooterNav={bottomFooterNav} siteSettings={siteSettings} contentComponents={contentComponents} contentComponentHero={contentComponentHero} appAccessLevel={appAccessLevel}  />
  </>)
}
